import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import Inputfield from '../Inputfield/Inputfield'
import classNames from 'classnames'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import styles from './DateTimePicker.css'

const options = {
  allowMultiple: true
}

@CSSModules(styles, options)
export default class DateTimePicker extends Component {
  static propTypes = {
    date: PropTypes.string,
    dateInvalid: PropTypes.bool,
    disabled: PropTypes.bool,
    errorMessageDate: PropTypes.string,
    errorMessageTime: PropTypes.string,
    hoursInvalid: PropTypes.bool,
    minutesInvalid: PropTypes.bool,
    onDateChange: PropTypes.func,
    onTimeBlur: PropTypes.func,
    onTimeChange: PropTypes.func,
    onTimePartChange: PropTypes.func,
    time: PropTypes.string,
    title: PropTypes.string
  }

  constructor (props) {
    super(props)
    this.state = {
      disabled: props.disabled,
      minDate: moment(),
      maxDate: moment().add(89, 'days'),
      dateHasError: false
    }
    this._onTimeBlur = this._onTimeBlur.bind(this)
    this._onHoursChange = this._onHoursChange.bind(this)
    this._onMinutesChange = this._onMinutesChange.bind(this)
  }

  _onTimeBlur () {
    this.props.onTimeBlur(this.state.hours, this.state.minutes)
  }

  _onHoursChange (event) {
    const value = event.target.value
    this.props.onTimePartChange(value + ':' + this.state.minutes)
  }

  _onMinutesChange (event) {
    const value = event.target.value
    this.props.onTimePartChange(this.state.hours + ':' + value)
  }

  render () {
    const { errorMessageDate, errorMessageTime, time, title, date, dateInvalid, hoursInvalid, minutesInvalid, onDateChange } = this.props
    const t = time.split(':')
    if (t.length == 2) {
      /* eslint-disable react/no-direct-mutation-state */
      this.state.hours = t[0]
      this.state.minutes = t[1]
      /* eslint-enable react/no-direct-mutation-state */
    }
    const datePickerClasses = classNames('date-picker', { 'has-error': dateInvalid })
    const hoursClasses = classNames({ 'has-error': hoursInvalid })
    const minutesClasses = classNames({ 'has-error': minutesInvalid })

    return (
      <div styleName="date-picker-container">
        <h2>{title}</h2>       
        <div styleName="row">
          <div styleName="date-wrapper">
          <DatePicker
            className={datePickerClasses}
            locale="sv-se"
            maxDate={this.state.maxDate}
            minDate={this.state.minDate}
            onBlur={onDateChange} 
            onChange={onDateChange}
            selected={moment(date)}
          />
          </div>
          <div styleName="time-wrapper">
            <Inputfield
              inputClasses={hoursClasses}
              max="23"
              min="0"
              onBlur={this._onTimeBlur}
              onChange={this._onHoursChange}
              type="number"
              value={this.state.hours} 
            />
            <span styleName="time-separator">:</span>
            <Inputfield
              errorMessage={errorMessageDate ? errorMessageDate : errorMessageTime}
              inputClasses={minutesClasses}
              max="59"
              min="0"
              onBlur={this._onTimeBlur}
              onChange={this._onMinutesChange}
              type="number"
              value={this.state.minutes} 
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DateTimePicker/DateTimePicker.js